export default "__VITE_ASSET__D08mYyKq__"